var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-flex-col"},[_c('ChatMessagesBox',{staticClass:"tw-grow tw-w-full"}),_vm._v(" "),_c('ChatInputBox',{attrs:{"is-disabled":_vm.isDisabled,"disabled-message":_vm.disabledMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }